import { render, staticRenderFns } from "./DeliveryNotesIndex.vue?vue&type=template&id=894166ce&scoped=true"
import script from "./DeliveryNotesIndex.vue?vue&type=script&lang=js"
export * from "./DeliveryNotesIndex.vue?vue&type=script&lang=js"
import style0 from "./DeliveryNotesIndex.vue?vue&type=style&index=0&id=894166ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "894166ce",
  null
  
)

export default component.exports